import { makeAutoObservable, runInAction } from "mobx";
import { Store, IMotiTagStore, AllMotiTagData, UploadCSVResult } from "../global/types";
import { getAllMotiTagsData, uploadMotiTagsCSV } from "../api/user.action"

class MotiTagStore implements IMotiTagStore {
    rootStore: Store;
    allMotiTagsData: AllMotiTagData[] = [];
    motiTagsData: AllMotiTagData | null = null;
    error: string | null = null;
    loading: boolean = false;
    page: number = 1;
    searchTerm: string = '';
    limit: number = 10;
    totalItems: number = 0;
    totalPages: number = 0;
    customerId: string = '';

    constructor(rootStore: Store) {
        makeAutoObservable(this);
        this.rootStore = rootStore;
    }

    setLoading = (loading: boolean) => {
        this.loading = loading;
    }

    fetchAllMotiTagsData = async (
        action: 'change_page' | 'search' | 'change_limit' | 'change_filter' | '',
        page: number,
        searchTerm: string,
        limit: number
    ) => {
        this.setLoading(true);
        try {
            runInAction(() => {
                switch (action) {
                    case 'change_page':
                        this.page = page;
                        break;
                    case 'search':
                        this.searchTerm = searchTerm;
                        this.page = 1;
                        break;
                    case 'change_limit':
                        this.limit = limit
                        this.page = 1
                        break;
                    default:
                        break;
                }
            })
            const data = {
                page: this.page,
                limit: this.limit,
                search: this.searchTerm?.trim()
            }
            const response = await getAllMotiTagsData(data);
            runInAction(() => {
                this.allMotiTagsData = response.data?.moti_tags || [];
                this.totalItems = response.data?.totalItems;
                this.totalPages = response.data?.totalPages;
            })
        } catch (error: unknown) {
            this.rootStore.authStore.handleUnauthorized(error);
        } finally {
            this.setLoading(false);
        }
    }

uploadCSV = async (formData: FormData): Promise<UploadCSVResult> => {
    this.setLoading(true);
    try {
        const response = await uploadMotiTagsCSV(formData);
        return response.data;
    } catch (error: unknown) {
        this.rootStore.authStore.handleUnauthorized(error);
        // Return error result instead of throwing
        return {
            success: false,
            message: 'Upload failed',
            filename: '',
            type: '',
            summary: {
                totalRecords: 0,
                inserted: 0,
                skipped: 0,
                errors: 1
            },
            errors: [{
                row: 0,
                error: error instanceof Error ? error.message : 'Unknown error',
                data: {}
            }]
        };
    } finally {
        this.setLoading(false);
    }
}

    resetMotiTagPageDataStates = () => {
        runInAction(() => {
            this.allMotiTagsData = [];
            this.motiTagsData = null;
            this.error = null;
            this.loading = false;
            this.page = 1;
            this.searchTerm = '';
            this.limit = 10;
            this.totalItems = 0;
            this.totalPages = 0;
            this.customerId = '';
        })
    }
}

export default MotiTagStore;
